import {Component, OnInit, Input} from '@angular/core';
import { CommandGridInputModel } from '../command-gridinput.model';
import { Model_SoudotecDocument } from '../../soudotec.models';

@Component({
    selector: 'abw-command-gridinput-result',
    templateUrl: './command-gridinput-result.component.html',
    styleUrls: ['./command-gridinput-result.component.scss']
})
export class CommandGridInputResultComponent implements OnInit {
	@Input() model: CommandGridInputModel;
    @Input() value: Model_SoudotecDocument;

    constructor() {
    }

    ngOnInit() {
    }
}